import React, { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useCartContext } from "../context/CartContext";
import { BASE_URL } from '../constants';

const categories = [
  "All",
  "necklaces",
  "bracelets",
  "earrings",
  "rings",
  "anklets",
];

const NewArrivalProduct = ({ newproduct = [] }) => {
  const [activeTab, setActiveTab] = useState("All");

  const { addItemToCart } = useCartContext();

  // Filter Products
  const filteredProducts =
    activeTab === "All"
      ? newproduct
      : newproduct.filter(
        (item) =>
          item.category_name?.toLowerCase() ===
          activeTab.toLowerCase()
      );

  // Add To Cart
  const handleAddToCart = (item) => {
    
    addItemToCart({
      product: item.id, // ✅ FIXED
      name: item.name,
      price: parseFloat(item.price),
      old_price: item.old_price || "",
      image: item.image,
      stock: 10,
      seller: item.brand || "",
      contains_in_box: "",
      product_type: "simple",
      quantity: 1,
      category_id:item.category_id || "",
    });
  };

  return (
    <section className="py-5" style={{ background: "#f5f5f5" }}>
      {/* Heading */}
      <div className="discover-heading text-center mb-4">
        <span>Latest</span>
        <h2>Designs</h2>
      </div>

      <Container>
        {/* Category Tabs */}
        <Nav
          variant="pills"
          className="justify-content-center mb-4 custom-tabs"
        >
          {categories.map((cat, index) => (
            <Nav.Item key={index}>
              <Nav.Link
                eventKey={cat}
                active={activeTab === cat}
                onClick={() => setActiveTab(cat)}
                className="text-uppercase"
                style={{ cursor: "pointer" }}
              >
                {cat}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {/* Product Grid */}
        <Row className="g-3">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((item) => (
              <Col
                key={item.id}
                xs={6}
                sm={6}
                md={4}
                lg={3}
                className="mb-4"
              >
                
                   <div className="product-card">
                  {/* Product Image */}
                <Link to={`/products/${item.slug}`}  state={{ item }}>
                  <div className="image-wrapper">
                    <img
                      src={
                        BASE_URL +
                        (item.image?.replace(/\\/g, "/") || "")
                      }
                      alt={item.name}
                      className="main-img img-fluid"
                    />

                    <img
                      src={
                        BASE_URL +
                        (item.image?.replace(/\\/g, "/") || "")
                      }
                      alt={item.name}
                      className="hover-img img-fluid"
                    />
                  </div>
                </Link>
                  {/* Wishlist */}
                  <div className="wishlist-icon">
                    <i className="bi bi-heart"></i>
                  </div>

                  {/* Product Info */}
                  <div className="product-info text-center mt-3">
                    <h6 className="product-name">
                      {item.name}
                    </h6>

                    <div className="price-section mb-3">
                      <span className="discount-price fw-bold">
                        ₹{item.price}
                      </span>

                      {item.old_price && (
                        <span
                          className="original-price text-muted ms-2"
                          style={{
                            textDecoration: "line-through",
                          }}
                        >
                          ₹{item.old_price}
                        </span>
                      )}
                    </div>
                  
                    {/* Add To Cart Button */}
                    <button
                      className="add-to-cart-btn btn btn-dark w-100"
                      onClick={() => handleAddToCart(item)}
                      style={{
                        position: "relative",
                        zIndex: 999,
                        pointerEvents: "auto",
                      }}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
                
               
              </Col>
            ))
          ) : (
            <div className="text-center">
              <h5>No Products Found</h5>
            </div>
          )}
        </Row>

        {/* View All Button */}
        <div className="text-center mt-4">
          <Link
            to={
              activeTab.toLowerCase() === "all"
                ? "/collection/new-arrival"
                : `/collection/${activeTab}`
            }
            className="view-all-btn btn btn-outline-dark text-decoration-none"
          >
            View All
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default NewArrivalProduct;